import { ConfigSetting } from 'Modules'
import { atom } from 'nanostores'

export const $configSetting = atom<ConfigSetting | null>(null)

export const setConfigSetting = (setting: ConfigSetting | null) => {
  $configSetting.set(setting)
}

/**
 * Trả về IPFS gateway dạng đầy đủ, ví dụ: https://dweb.link/ipfs/
 */
export const getIpfsGatewayBaseUrl = (): string => {
  const raw = $configSetting.get()?.ipfs_gateway_base_url?.trim()
  if (!raw) {
    throw new Error('ipfs_gateway_base_url is not configured')
  }
  return raw
}
